import { render, staticRenderFns } from "./identityInfo.vue?vue&type=template&id=dbb3af90&"
import script from "./identityInfo.vue?vue&type=script&lang=js&"
export * from "./identityInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports